import {
  createApiFactory,
  createPlugin,
  createRoutableExtension,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';
import { rootRouteRef } from './routes';
import { maintainersApiRef, MaintainersClient } from './api';

export const maintainersPlugin = createPlugin({
  id: 'maintainers',
  apis: [
    createApiFactory({
      api: maintainersApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
      },
      factory({ discoveryApi, fetchApi }) {
        return new MaintainersClient({ discoveryApi, fetchApi });
      },
    }),
  ],
  routes: {
    root: rootRouteRef,
  },
});

export const MaintainersPage = maintainersPlugin.provide(
  createRoutableExtension({
    name: 'MaintainersPage',
    component: () =>
      import('./components/MaintainersComponent').then(
        m => m.MaintainersComponent,
      ),
    mountPoint: rootRouteRef,
  }),
);
